import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Dotdotdot from 'react-dotdotdot';
import styled, { css } from 'styled-components';
import { Avatar } from "../../avatar/src";
import { Box } from "../../box/src";
import { Card } from "../../card/src";
import { DefaultLinkSimple } from "../../link/src";
import { linkControlledHoverEffect } from "../../theme/src";
const CardContent = ({ firstName, firstSubTitle, lastName, picture, secondSubTitle, }) => (_jsxs(_Fragment, { children: [_jsx(Box, { justifyContent: "center", width: "100%", children: _jsx(AvatarWrapper, { children: _jsx(Avatar, { alt: "", src: picture }) }) }), _jsxs(Box, { flexDirection: "column", minHeight: 59, children: [(firstName || lastName) && (_jsx(Dotdotdot, { clamp: 1, useNativeClamp: true, children: _jsxs(Title, { font: "h4-semibold", mt: 3, children: [firstName, " ", lastName] }) })), firstSubTitle && (_jsx(Dotdotdot, { clamp: 1, useNativeClamp: true, children: _jsx(SubTitle, { font: "body-regular-black", children: firstSubTitle }) })), secondSubTitle && (_jsx(Dotdotdot, { clamp: 1, useNativeClamp: true, children: _jsx(SubTitle, { font: "body-regular-black", children: secondSubTitle }) }))] })] }));
export const UserPresentationCard = ({ firstName, firstSubTitle, icon = '', lastName, link = '', picture, secondSubTitle, target = '_blank', }) => {
    const withLink = !!link;
    return (_jsxs(UserCard, { "$withHoverEffect": withLink, "data-testid": "user-presentation-card", children: [_jsx(Icon, { children: icon }), withLink ? (_jsx(DefaultLinkSimple, { href: link, target: target, children: _jsx(CardContent, { firstName, firstSubTitle, lastName, picture, secondSubTitle }) })) : (_jsx(CardContent, { firstName, firstSubTitle, lastName, picture, secondSubTitle }))] }));
};
const Icon = styled(Box).attrs(() => ({
    fontSize: 6,
    position: 'absolute',
})) ``;
const AvatarWrapper = styled(Box).attrs(() => ({
    height: 72,
    justifyContent: 'center',
    mt: 1,
    width: 72,
})) `
  border-radius: 50%;
  overflow: hidden;
`;
const SubTitle = styled(Box).attrs(() => ({
    display: 'block',
    mt: 2,
    textAlign: 'center',
})) ``;
const Title = styled(Box).attrs(() => ({
    display: 'block',
    textAlign: 'center',
})) ``;
const UserCard = styled(Card).attrs(() => ({
    flexDirection: 'column',
    height: '100%',
    pb: 5,
    pt: 4,
})) `
  ${({ $withHoverEffect }) => $withHoverEffect && cssHoverEffect}
`;
const cssHoverEffect = css `
  &:hover ${Title} {
    ${linkControlledHoverEffect}
    text-decoration: underline !important
  }

  & ${AvatarWrapper} {
    transition: transform 0.3s;
    transform: scale(1.05);
  }

  &:hover ${AvatarWrapper} {
    transform: scale(1.1);
  }
`;
//# sourceMappingURL=UserPresentationCard.js.map